import { AgencyActivityDto, ContactFormDto, IAgency, IAgencyActivity } from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class AdminApi {
  static contactForm(dto: ContactFormDto): Promise<AxiosResponse> {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/admin/contact`,
      data: dto,
    });
  }

  static getAgencies(): Promise<AxiosResponse<IAgency[]>> {
    return AdmiralApi.apiCall<IAgency[]>({
      method: 'POST',
      url: `${BASE_URL}/admin/agencies`,
    });
  }

  static getActivity(): Promise<AxiosResponse<IAgency[]>> {
    return AdmiralApi.apiCall<IAgency[]>({
      method: 'GET',
      url: `${BASE_URL}/admin/activity`,
    });
  }

  static getAgencyActivity(dto: AgencyActivityDto): Promise<AxiosResponse<IAgencyActivity>> {
    return AdmiralApi.apiCall<IAgencyActivity>({
      method: 'POST',
      data: dto,
      url: `${BASE_URL}/admin/agencies/activity`,
    });
  }

  static getOnlineAgencies(): Promise<AxiosResponse<IAgency[]>> {
    return AdmiralApi.apiCall<IAgency[]>({
      method: 'POST',
      url: `${BASE_URL}/admin/agencies/online`,
    });
  }

  static createAnnouncement(dto: AgencyActivityDto): Promise<AxiosResponse<IAgencyActivity>> {
    return AdmiralApi.apiCall<IAgencyActivity>({
      method: 'POST',
      data: dto,
      url: `${BASE_URL}/admin/agencies/activity`,
    });
  }
}
